import cx from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useHistory, useLocation } from "react-router-dom";
import { AlphaVer, ICDark, ICDoc, ICEuro, ICSpeedSwap, ICSun } from '../../../assets';
import { ThemeContext } from '../../../context/themeContext';
import { Spacer } from '../../atoms';
import { SidebarItem } from '../../molecules';
import MenuItem from './MenuItem';
import './Sidebar.scss';

export default function Sidebar({ closeSide }) {
  const history = useHistory();

  const { setTheme } = useContext(ThemeContext)
  const localTheme = localStorage.getItem('localTheme');

  const [classDark, setClassDark] = useState('dark')
  const [classLight, setClassLight] = useState('light')
  const [ek, setEk] = useState("1")

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    if (path === '/whale') {
      setEk("2")
    }
    setTheme(localTheme)
    if (localTheme) {
      if (localTheme === 'dark') {
        setClassDark('dark active');
        setClassLight('light');
      } else {
        setClassDark('dark');
        setClassLight('light active');
      }
    } else {
      setClassDark('dark');
      setClassLight('light active');
    }
  }, [localTheme, setTheme, path])
  const changeMode = (mode) => {
    if (mode === 'dark') {
      setClassDark('dark active');
      setClassLight('light');
    } else {
      setClassDark('dark');
      setClassLight('light active');
    }
    setTheme(mode)
    localStorage.setItem('localTheme', mode)
  }

  const classSidebar = cx({
    'sideBar': true,
    'scrollCustom': true,
    'minimize': closeSide
  })

  return (
    <div className={classSidebar}>
      <div className="sideBarIll seratus"></div>
      <div className="sideBarIll duaratus"></div>
      <Spacer h={30} />
      <div className="sidebarBody scrollCustom">
        <SidebarItem title="Home" onClick={() => history.push('/')} />
        <SidebarItem title="Deficandy Bot" onClick={() => history.push('/bot')} />
        <SidebarItem title="Token Inspector" onClick={() => history.push('/token_inspector')} />
        <Spacer h={20} />
        <Accordion flush defaultActiveKey={ek}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <img className="menuIcon" src={ICEuro} alt="" />
              <span className="menuText">Follow Whales</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="itemChildMenu">
                <MenuItem title="Net Transfer" href="/whale" />
                <Spacer h={20} />
                <MenuItem title="Balance History" href="/balance_history" />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Spacer h={20} />

        <Accordion flush defaultActiveKey={ek}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <img className="menuIcon" src={ICSpeedSwap} alt="" />
              <div className="menuText">Speed Swap <img className="alpha" src={AlphaVer} alt="alpha" /></div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="itemChildMenu">
                <MenuItem title="Single Wallet" href="/fasttrax" />
                <Spacer h={20} />
                <MenuItem title="Multiple Wallets" href="/multiwallet" />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Spacer h={20} />
        <Accordion flush defaultActiveKey={ek}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div className="menuIcon" />
              <div className="menuText">NFT Tools <img className="alpha" src={AlphaVer} alt="alpha" /></div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="itemChildMenu">
                <MenuItem title="Mint Bot" href="/mintbot" />
                <Spacer h={20} />
                <MenuItem title="Top ID" href="/topid" />
                <Spacer h={20} />
                <MenuItem title="True Holder" href="/trueholder" />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Spacer h={20} />
        {/* <Accordion flush defaultActiveKey={ek}>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <img className="menuIcon" src={ICMoreApp} alt="" />
              <span className="menuText">More to come...</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="itemChildMenu">
                <MenuItem title="Trust Me" href="/applist/trust_me" />
                <Spacer h={20} />
                <MenuItem title="Trendings" href="/applist/trendings" />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> */}
        <Spacer h={20} />
        <Accordion flush defaultActiveKey={ek}>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <img className="menuIcon" src={ICDoc} alt="" />
              <span className="menuText">Documentation</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="itemChildMenu">
                <MenuItem title="Logo Pack" href="logopack" />
                <Spacer h={10} />
                <MenuItem title="Tokenomics" href="tokenomic" />
                <Spacer h={10} />
                <MenuItem title="Milestone" href="milestone" />
                <Spacer h={10} />
                {/* <MenuItem title="Tier System" href="tier" />
                <Spacer h={10} />
                <MenuItem title="Roadmap" href="roadmap" />
                <Spacer h={10} />
                <MenuItem title="Open Github Repo" href="/" />
                <Spacer h={10} />
                <MenuItem title="Medium" href="/" />
                <Spacer h={10} />
                <MenuItem title="Twitter" href="/" /> */}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Spacer h={20} />
      <div className="swicthMode">
        <div className="icon">
          <div className={classLight} onClick={() => changeMode('light')}>
            <img src={ICSun} alt="" />
          </div>
          <span className="or"> / </span>
          <div className={classDark} onClick={() => changeMode('dark')}>
            <img src={ICDark} alt="" />
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}
